exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-info {\n  margin-top: 30px;\n}\n\n.file-info .file-name-section{\n  font-size: 18px;\n  font-weight: 300;\n}\n\n.file-info .file-name-section .file-name{\n  font-weight: 500;\n}\n\n.alert p {\n  margin-bottom: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/cargar-codigos/cargar-codigos.component.css
// module id = ../../../../../src/app/pages/admin/cargar-codigos/cargar-codigos.component.css
// module chunks = main